import React from 'react';

import SectionHeading from './SectionHeading';

// import Swiper React components
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';

// images
import screen_1 from '../../assets/images/slider/slider-0.svg';
import screen_2 from '../../assets/images/slider/slider-1.svg';
import screen_3 from '../../assets/images/slider/slider-2.svg';
import screen_4 from '../../assets/images/slider/slider-3.svg';
import screen_5 from '../../assets/images/slider/slider-4.svg';
// TODO put new images

const ScreenSlider = () => {

    const data = [
        {
            src: screen_3
        },
        {
            src: screen_4
        },
        {
            src: screen_5
        },
        {
            src: screen_1
        },
        {
            src: screen_2
        }
    ]

    return (
        <>
            {/* screen section header - start */}
            <div className="container" >
                <div className="row">
                    <div className="col-lg-8 offset-lg-0 col-10 offset-1">
                        <div className="screen-section-header">
                            <h1 class="text-inter" style={{color:"black"}}>El lugar más transparente <br></br> para tu búsqueda laboral.</h1>
                        </div>
                    </div>
                    <div className="col-lg-4 offset-lg-0 col-10 offset-1">
                        <div className="screen-slider-navigation slider-navigation">
                            <div className="screen-slider-navigation-prev">
                                <i className="las la-long-arrow-alt-left"></i>
                            </div>
                            <div className="screen-slider-navigation-next">
                                <i className="las la-long-arrow-alt-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* screen section header - end */}
            {/* screen section slider - start */}
            <div className="screen-slider">
                <Swiper
                    modules={[Navigation]}
                    spaceBetween={30}
                    navigation={{
                            nextEl: '.screen-slider-navigation-prev',
                            prevEl: '.screen-slider-navigation-next'
                    }}
                    centeredSlides={true}
                    loop={true}
                    breakpoints={{
                        0: {
                            slidesPerView: 1.8
                        },
                        576: {
                            slidesPerView: 2.4
                        },
                        768: {
                            slidesPerView: 2.8
                        },
                        992: {
                            slidesPerView: 4.8
                        }
                    }}
                >
                    {
                        data.map((element, key) => {
                            return (
                                <SwiperSlide key={key}>
                                    <div className="screen-slide">
                                        <figure>
                                            <img src={element.src} alt="app-screen" />
                                        </figure>
                                    </div>
                                </SwiperSlide>
                            );
                        })
                    }
                </Swiper>
            </div>
            {/* screen section slider - end */}  
        </>
    );
};

export default ScreenSlider;
